import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import { usePreventContextMenu } from "@/hooks";

const SearchInputField = forwardRef((props, ref) => {
  const { className, ..._props } = props;
  const [on, off] = usePreventContextMenu();

  return (
    <div className={styles.searchInputField}>
      <input
        ref={ref}
        className={classnames(styles.searchInput, className)}
        defaultValue=""
        type="search"
        autoComplete="off"
        onFocus={off}
        onBlur={on}
        {..._props}
      />
    </div>
  );
});
SearchInputField.displayName = "SearchInputField";
export default SearchInputField;
